import { useState } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Stack } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

function CollapsibleProfileSection({ title, summary, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Accordion
      expanded={open}
      onChange={() => setOpen(!open)}
      disableGutters
      sx={{
        borderRadius: '12px !important',
        boxShadow: '0 1px 3px rgba(20, 10, 50, 0.06)',
        border: '1px solid rgba(20, 10, 50, 0.06)',
        '&:before': { display: 'none' },
        overflow: 'hidden',
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: { xs: 2.5, sm: 3.5 }, py: 1 }}>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
          <Box sx={{ width: 4, height: 20, borderRadius: 2, bgcolor: 'primary.main' }} />
          <Box>
            <Typography fontWeight={700}>{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {summary}
            </Typography>
          </Box>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ px: { xs: 2.5, sm: 3.5 }, pb: 3 }}>{children}</AccordionDetails>
    </Accordion>
  );
}

export default CollapsibleProfileSection;
